/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HousePlanStyle } from '@gh/builder-shared-data';

import { ROW_DELETED_CLASS } from '@gh/common-internal-shared';
import { EnumDictionary, getRouteInitData } from '@gh/common-shared';
import { LayoutBasedGridDefinition } from '@gh/core-ui-grid';
import { asString } from '@gh/core-util';

import { GridOptions } from 'ag-grid-community';
import { assign } from 'lodash';

import { HousePlanListItem } from '../../resources/house-plans.model';

@Injectable()
export class HousePlanGridDefinition extends LayoutBasedGridDefinition {

  columnDefs = {
    style: {
      valueFormatter: (params: any) => asString(this.housePlanStyles.get(params.value)),
    },
  };

  private housePlanStyles: EnumDictionary<HousePlanStyle>;

  constructor(private route: ActivatedRoute) {
    super();

    const { housePlanStyles } = getRouteInitData(route);

    assign(this, { housePlanStyles });
  }

  buildGridOptions(): GridOptions {
    return {
      rowClassRules: {
        [ROW_DELETED_CLASS]: ({ data }: { data: HousePlanListItem }) => !data.isActive,
      },
      getRowId: (params) => String(params.data.housePlanId),
    };
  }
}
